import type { FC } from 'react';

import { ScSwitchButton, type ScSwitchButtonProps } from './styled';

interface SwitchButtonProps extends ScSwitchButtonProps {
  id: string;
  onChange?: (arg: any) => void;
  labelChecked?: string;
  labelUnchecked?: string;
  disabled?: boolean;
}

export const SwitchButton: FC<SwitchButtonProps> = ({
  id,
  isChecked,
  disabled,
  onChange,
  labelChecked,
  labelUnchecked,
  ...rest
}) => (
  <ScSwitchButton
    data-checked={labelChecked}
    data-unchecked={labelUnchecked}
    htmlFor={id}
    isChecked={isChecked}
    {...rest}
  >
    <input
      checked={isChecked}
      disabled={disabled}
      id={id}
      onChange={onChange}
      type="checkbox"
    />
    <span className="slider" />
  </ScSwitchButton>
);
